import { call, put, takeEvery, select, delay } from 'redux-saga/effects';
import * as mailActions from '../actions/mail';
import { getAllMailHistoryRequest, mailSendRequest } from '../../api/mail';
import history from '../../../../../common/history';
import { errorProcessing } from '../../../../Employees/api/errorProcessing';
import showSuccessWindow from '../../../../../common/components/successPopup/successPopup';
import { successMailSend } from '../../components/OrderCard/popup/success';

const getActiveProfileId = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.profileId
  );
};

function* getAllMailHistorySaga() {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(getAllMailHistoryRequest, activeProfileId);
      yield put(mailActions.getAllMailHistorySuccess(response));
    } catch (err) {
      yield put(mailActions.getAllMailHistoryError(errorProcessing(err)));
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(mailActions.getAllMailHistory())
      : history.push('/authorization/profiles');
  }
}

function* mailSendSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(
        mailSendRequest,
        activeProfileId,
        action.payload
      );
      yield put(mailActions.mailSendSuccess(response));
      showSuccessWindow(successMailSend(response.recipient));
    } catch (err) {
      yield put(mailActions.mailSendError(errorProcessing(err)));
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(mailActions.mailSend(action.payload))
      : history.push('/authorization/profiles');
  }
}

export function* mailConfigWatcher() {
  yield takeEvery(
    mailActions.getAllMailHistory.toString(),
    getAllMailHistorySaga
  );
  yield takeEvery(mailActions.mailSend.toString(), mailSendSaga);
}
